var map = {
	"./abx.svg": [
		5230,
		230
	],
	"./ada.svg": [
		1293,
		293
	],
	"./alp.svg": [
		6820,
		820
	],
	"./avax.svg": [
		7161,
		161
	],
	"./blur.svg": [
		5180,
		180
	],
	"./bnb.svg": [
		2087,
		87
	],
	"./btc.svg": [
		3396,
		396
	],
	"./cetus.svg": [
		1797,
		797
	],
	"./doge.svg": [
		4200,
		200
	],
	"./dot.svg": [
		7300,
		300
	],
	"./eth.svg": [
		1992,
		992
	],
	"./fsui.svg": [
		1772,
		772
	],
	"./ltc.svg": [
		3874,
		874
	],
	"./pepe.svg": [
		3995,
		995
	],
	"./sol.svg": [
		695,
		695
	],
	"./sui.svg": [
		7688,
		688
	],
	"./usd.svg": [
		465,
		465
	],
	"./usdc.svg": [
		7920,
		920
	],
	"./usdt.svg": [
		5471,
		471
	],
	"./wld.svg": [
		8142,
		142
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4683;
module.exports = webpackAsyncContext;